//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from 'lodash/throttle';
import PDPCommentNode from './PDPCommentNode.vue';

export default {
  name: 'PDPComment',
  components: {
    PDPCommentNode,
  },
  inject: {
    forDiscussionPage: {
      default: false,
    },
  },
  props: {
    allowFlagging: {
      type: Boolean,
      default: false,
    },
    filterComments: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
    commentLink: {
      type: Object,
      default: () => ({}),
    },
    commentTypeTitle: {
      type: String,
      required: true,
    },
    dealPartnerUserIds: {
      type: Array,
      required: true,
    },
    isPinned: {
      type: Boolean,
    },
    positionIndices: {
      type: Array,
      default: () => ([]),
    },
    forceShowAll: {
      type: Boolean,
    },
    highlightComment: {
      type: String,
      default: '',
    },
    showAllChildren: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    updateState: {
      type: Object,
      default: () => ({}),
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      hideReplies: false,
    };
  },
  methods: {
    updateAction: throttle(function handler(data) {
      this.$emit('update-action', data);
    }, 200),
    replyComment(data) {
      this.$emit('reply-comment', data);
    },
    onClickClear() {
      this.$emit('on-click-clear');
    },
  },
};
